import {i18n} from '@yourcoach/i18n';

import type {Props} from './types';

type Variant = Props['variant'];

export const getTitle = (variant: Variant) => {
  switch (variant) {
    case 'food_diary':
      return i18n.t('shared:food_diary.title');
    case 'trackers':
      return i18n.t('shared:trackers');
    default:
      return i18n.t('shared:coming_soon');
  }
};

export const getDescription = (variant: Variant) => {
  switch (variant) {
    case 'food_diary':
      return i18n.t('shared:meal_nutrition_tracking');
    case 'trackers':
      return i18n.t('shared:weight_and_other_trackers');
    default:
      return '';
  }
};

export const getClientBgColor = (variant: Variant) => {
  switch (variant) {
    case 'food_diary':
      return '#7ECBB6';
    case 'trackers':
      return '#7577AE';
    case 'unknown_service_1':
      return '#5C97EE';
    default:
      return '#000';
  }
};

export const getCoachBgColor = (variant: Variant) => {
  switch (variant) {
    case 'food_diary':
      return '#7ECBB6';
    case 'trackers':
      return '#7577AE';
    case 'unknown_service_1':
      return '#A7C0E5';
    default:
      return '#000';
  }
};
